import Image from "next/image";
import { BRAND_SOCIALS } from "@/lib/socials";

type BrandSocialIconsProps = {
  className?: string;
  /** Pixel size of each logo (default 28). */
  size?: number;
  /** Accessible label for the nav group */
  ariaLabel: string;
};

export function BrandSocialIcons({
  className = "",
  size = 28,
  ariaLabel,
}: BrandSocialIconsProps) {
  return (
    <nav className={`flex items-center justify-center gap-3 ${className}`} aria-label={ariaLabel}>
      {BRAND_SOCIALS.map((social) => (
        <a
          key={social.id}
          href={social.href}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center justify-center w-11 h-11 rounded-xl hover:bg-slate-100 dark:hover:bg-slate-800/80 transition-colors"
          aria-label={social.label}
        >
          <Image
            src={social.iconSrc}
            alt=""
            width={size}
            height={size}
            className="rounded-[6px] pointer-events-none"
            unoptimized
          />
        </a>
      ))}
    </nav>
  );
}
